import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import FlowLayoutItemT from '@/Controls/FlowLayoutItem';
import LayoutRendererT from '@/Utility/LayoutRenderer';

export default class FlowLayoutBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.flowLayout = {
            init: (node: HTMLElement, valueAccessor: () => any) => {
                let layout = $(node);
                let options = valueAccessor();

                let FlowLayout = ComponentManager.getControl('FlowLayout');
                let FlowLayoutItem = ComponentManager.getControl<typeof FlowLayoutItemT>('FlowLayoutItem');
                let LayoutRenderer = ComponentManager.getUtility<typeof LayoutRendererT>('LayoutRenderer');
                let items = options.items();

                options.parent.elements = [];

                if (options.mode === 'ColumnBased' || options.orientation === 'Vertical') {
                    let innerLayout = LayoutRenderer.renderColumnLayout(options.columnLayout.columnsPerRow, options.columnLayout.tuples);

                    ko.utils.domNodeDisposal.addDisposeCallback(layout[0], () => {
                        LayoutRenderer.disposeColumnLayout(innerLayout);
                    });

                    innerLayout.appendTo(layout);
                }
                else {
                    for (let i = 0; i < items.length; i++) {
                        let flowLayoutItem = new FlowLayoutItem(items[i], $('<div>').appendTo(layout));
                        let tuple = flowLayoutItem.getTuple();

                        options.parent.elements.push(flowLayoutItem);
                    }

                    $('<div class="clear">').appendTo(layout);
                }
            }
        };
    }
}